import { defineComponent, h } from "vue";

const svgProps = {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};

const rect = (attrs: Record<string, number>) =>
  h("rect", { ...attrs, rx: 1, fill: "currentColor" });

export default defineComponent({
  name: "CaptionInlineIcon",
  render: () =>
    h("svg", svgProps, [
      rect({ x: 1, y: 9, width: 3, height: 2 }),
      rect({ x: 5.5, y: 6, width: 2.5, height: 8 }),
      rect({ x: 9, y: 6, width: 2.5, height: 8 }),
      rect({ x: 12.5, y: 6, width: 2.5, height: 8 }),
      rect({ x: 16, y: 9, width: 3, height: 2 }),
    ]),
});
